import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryCards() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            漫画分类
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            按主题浏览你感兴趣的漫画内容，找到最适合你的育儿读物
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex items-start gap-4 p-5 rounded-lg bg-background-50 border border-background-200/60 hover:border-accent-200 transition-all duration-300 no-underline"
            >
              <div className="w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-md text-xl" style={{ backgroundColor: 'oklch(var(--accent-100))', color: 'oklch(var(--accent-600))' }}>
                <i className={cat.icon}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-950 mb-1 group-hover:text-accent-600 transition-colors" style={{ fontFamily: 'var(--font-heading)' }}>
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-600 line-clamp-2 mb-2">
                  {cat.description}
                </p>
                <span className="text-xs text-foreground-500">
                  {cat.articleCount} 篇漫画
                </span>
              </div>
              <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center text-foreground-400 group-hover:text-accent-500 transition-colors">
                <i className="ri-arrow-right-s-line"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}